import type { ReactNode } from "react";
import { page } from "@web/theme/theme";

export type PageProps = { children: ReactNode; className?: string; as?: "main" | "div"; /** Full width (no centered column); used by the gallery. */ wide?: boolean; variant?: "workspace" | "reading" | "auth" | "collection" | "settings" | "today" };

/** Phone-first screen body; bounded staff workspaces stay left-aligned on desktop. */
export function Page({ children, className = "", wide = false, variant = "workspace", as: Tag = "main" }: PageProps) {
  return <Tag className={`${page} v365-page v365-page-${variant} ${variant === "today" ? "v365-today" : ""} ${wide ? "v365-page-wide max-w-none" : ""} ${className}`.trim()}>{children}</Tag>;
}
